import React, { useMemo } from 'react';
import { createHtmlPortalNode, InPortal, OutPortal } from 'react-reverse-portal';
import {
    WRAP,
    BOX,
    SUMMARY,
    VIDEO
} from './FinalViews';

const wrapPortalNode = createHtmlPortalNode();
const highlightPortalNode = createHtmlPortalNode();
const summaryPortalNode = createHtmlPortalNode();
const boxScorePortalNode = createHtmlPortalNode();

const usePortalController = (
    activeTab,
    views,
    options
) => {
    const {
        isTwoColumn
    } = options;

    const {
        wrap,
        boxScore,
        summary,
        video
    } = useMemo(() => ({
        wrap: <OutPortal node={wrapPortalNode} />,
        boxScore: <OutPortal node={boxScorePortalNode} />,
        summary: <OutPortal node={summaryPortalNode} />,
        video: <OutPortal node={highlightPortalNode} />
    }), []);

    const renderedMainView = useMemo(() => {
        switch (activeTab) {
            case WRAP:
                return wrap;
            case BOX:
                return boxScore;
            case SUMMARY:
                return summary;
            case VIDEO:
                return video;
        }
    }, [
        activeTab,
        wrap,
        boxScore,
        summary,
        video
    ]);

    const renderedPortals = useMemo(() => (
        <>
            <InPortal node={wrapPortalNode}>
                {activeTab === WRAP && views.wrap}
            </InPortal>
            <InPortal node={boxScorePortalNode}>
                {activeTab === BOX && views.box}
            </InPortal>
            <InPortal node={summaryPortalNode}>
                {(activeTab === SUMMARY || isTwoColumn) && views.summary}
            </InPortal>
            <InPortal node={highlightPortalNode}>
                {activeTab === VIDEO && views.video}
            </InPortal>
        </>
    ), [
        activeTab,
        isTwoColumn,
        views.summary,
        views.video,
        views.box,
        views.wrap
    ]);

    return {
        renderedMainView,
        renderedPortals,
        summary
    };
};

export default usePortalController;
